import apiFetch from '../apiFetch'

export default function (token, saleTypeId) {
  return apiFetch({ endPoint: `SaleType/${saleTypeId}/Recover`, method: 'PUT', body: null, token: token })
}
